module.exports = __webpack_public_path__ + "img/logoSTC.a41049d4.svg";